import { useDispatch } from "react-redux";

import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";
import { useSignalsManagementViewModel } from "app/pages/sales-intelligence/sub-modules/signals/hooks/useSignalsManagementViewModel";
import signalsService from "app/pages/sales-intelligence/sub-modules/signals/services/signalsService";
import {
    isSignalsManagementOpenAction,
    setInitialSelectedSignalType,
} from "app/pages/sales-intelligence/sub-modules/signals/store/action-creators";

import { StyledSignalsListTypes } from "./styles";

export const SignalsApiListTypesContainer = () => {
    const dispatch = useDispatch();
    const signalsModel = useSignalsManagementViewModel();

    /**
     * This list is a picker for configuring signals, so a type the account cannot use on this source is
     * no use here -- unlike the management modal, which keeps it to explain why. Which claim answers that
     * for a given source is the signals service's business, not this surface's.
     */
    const configurableSignalTypes = signalsModel.signalTypes.filter(
        ({ type }) => !signalsService.isSignalTypeLocked(type, signalsModel.signalSource),
    );

    const handleSignalTypeClick = (signalType: SignalType) => {
        dispatch(setInitialSelectedSignalType(signalType));
        dispatch(isSignalsManagementOpenAction(true));
    };

    return (
        <StyledSignalsListTypes
            signalTypes={configurableSignalTypes}
            signalsCountPerType={signalsModel.signalsCountPerType}
            onSignalTypeClick={handleSignalTypeClick}
            data-automation="signals-api-list-per-type-container"
        />
    );
};
